export const homeMedia = [
  {
    src: 'https://media.mylostudio.ai/marketing/home/neon-city.c80176b84148.mp4?md5=2LPnrUyviN_2CfsUz6idsg&expires=2082758400',
    poster:
      'https://media.mylostudio.ai/marketing/home/neon-city.8d787b649fa3.webp?md5=qkZqW0QRunPqs0YNOTqznA&expires=2082758400',
  },
  {
    src: 'https://media.mylostudio.ai/marketing/home/red-carpet.5278bac22be1.mp4?md5=HAJTLPNt5qSXk1UL4mezmw&expires=2082758400',
    poster:
      'https://media.mylostudio.ai/marketing/home/red-carpet.f98ecd1ae764.webp?md5=hM3k2H7LI8lcNKaP5VaSeQ&expires=2082758400',
  },
  {
    src: 'https://media.mylostudio.ai/marketing/home/race-track.17b7e2066f5f.mp4?md5=9xoTcF8sItxwPxN46pZIfQ&expires=2082758400',
    poster:
      'https://media.mylostudio.ai/marketing/home/race-track.4d3a67e01fb6.webp?md5=k96EvO0M1VnfOEzfIqVMOw&expires=2082758400',
  },
  {
    src: 'https://media.mylostudio.ai/marketing/home/story-shooting.800d1ed5c793.mp4?md5=3YU4nP0fDnSPeK7hz_TL-w&expires=2082758400',
    poster:
      'https://media.mylostudio.ai/marketing/home/story-shooting.0ca6899082b5.webp?md5=2puYElkCMVn0vVUi0DIRDw&expires=2082758400',
  },
  {
    src: 'https://media.mylostudio.ai/marketing/home/artist-entrance.84622f079bd9.mp4?md5=uhmzqOmG-PCUIFy8x-Xn6w&expires=2082758400',
    poster:
      'https://media.mylostudio.ai/marketing/home/artist-entrance.a20d51550df3.webp?md5=G9dCi6hDOLfZx18ezJFMww&expires=2082758400',
  },
  {
    src: 'https://media.mylostudio.ai/marketing/home/parallel-beat.b01fa24b6705.mp4?md5=mo0WFPFWT7RUzZWHoSwcXg&expires=2082758400',
    poster:
      'https://media.mylostudio.ai/marketing/home/parallel-beat.bc7762eca80c.webp?md5=zJ9Mt7jCXBr7Vu6oLC0QSQ&expires=2082758400',
  },
  {
    src: 'https://media.mylostudio.ai/marketing/home/nightline.0c7262fc3204.mp4?md5=7yqxWGJu20kM0GQVbOn0VA&expires=2082758400',
    poster:
      'https://media.mylostudio.ai/marketing/home/nightline.d842f338d81f.webp?md5=p4c2O5j5Gvv3b5YqKmnnag&expires=2082758400',
  },
  {
    src: 'https://media.mylostudio.ai/marketing/home/red-thread.5a2170cdd1b3.mp4?md5=ejaexWOt9EMtbHkT8ZH_5A&expires=2082758400',
    poster:
      'https://media.mylostudio.ai/marketing/home/red-thread.066b5c4f308e.webp?md5=h_pTcwArDQhjD1aBmBHexQ&expires=2082758400',
  },
  {
    src: 'https://media.mylostudio.ai/marketing/home/agent-3d-render.40bb03bd6f2e.mp4?md5=JADwthIAgpILNQC1MS4UPQ&expires=2082758400',
    poster:
      'https://media.mylostudio.ai/marketing/home/agent-3d-render.e842ec9cce9c.webp?md5=4qMG7NAQuEOv2xBaqcFlpw&expires=2082758400',
  },
  {
    src: 'https://media.mylostudio.ai/marketing/home/office-cctv.5e4f7427f037.mp4?md5=WPRj2CHrjh3YwT7EmpSL8Q&expires=2082758400',
    poster:
      'https://media.mylostudio.ai/marketing/home/office-cctv.121ad7b671d1.webp?md5=JnBE9Vo8C2LY9pm57SgFOg&expires=2082758400',
  },
  {
    src: 'https://media.mylostudio.ai/marketing/home/superfast-flight.b38004a79ef1.mp4?md5=kN-tYWc8JRQHbFOW52VCHw&expires=2082758400',
    poster:
      'https://media.mylostudio.ai/marketing/home/superfast-flight.96fc8d7e8a53.webp?md5=W0ENoZ5Ei9hprHMBpoLd-g&expires=2082758400',
  },
  {
    src: 'https://media.mylostudio.ai/marketing/home/orbital-presence.85bddd2405b9.mp4?md5=Q1XRUWwSriW5HSFgSxs-5g&expires=2082758400',
    poster:
      'https://media.mylostudio.ai/marketing/home/orbital-presence.be01a97b3b71.webp?md5=5-G_ClD0SElnTR5zBooj4A&expires=2082758400',
  },
  {
    src: 'https://media.mylostudio.ai/marketing/home/cgi-breakdown.76ae4e929612.mp4?md5=jfruttdERtHRNIGaxEzv8Q&expires=2082758400',
    poster:
      'https://media.mylostudio.ai/marketing/home/cgi-breakdown.4ddc95337bdb.webp?md5=c2XKEizy4WbtNTIue0hUcw&expires=2082758400',
  },
] as const;
